function initCustomCollapsedText() {
  const sections = document.querySelectorAll(".custom-collapsed-text");

  sections.forEach((section) => {
    const description = section.querySelector(".custom-collapsed-text__description");
    const blur = section.querySelector(".custom-collapsed-text__description-blur");
    const buttonsWrap = section.querySelector(".custom-collapsed-text__less-more-btns__wrap");
    const readMoreBtn = section.querySelector(".custom-collapsed-text__less-more-btn.read-more");
    const readLessBtn = section.querySelector(".custom-collapsed-text__less-more-btn.read-less");

    if (!description || !buttonsWrap || !readMoreBtn || !readLessBtn) return;

    const initialHeight = Number(description.dataset.height) || 210;

    description.style.height = "auto";

    const fullHeight = description.scrollHeight;
    const isCollapsible = fullHeight > initialHeight + 2;

    if (!isCollapsible) {
      description.style.height = "auto";
      buttonsWrap.hidden = true;

      if (blur) {
        blur.style.opacity = "0";
        blur.style.display = "none";
      }

      return;
    }

    description.style.height = `${initialHeight}px`;
    buttonsWrap.hidden = false;

    if (blur) {
      blur.style.display = "";
      blur.style.opacity = "1";
    }

    readMoreBtn.classList.add("active");
    readLessBtn.classList.remove("active");

    readMoreBtn.addEventListener("click", () => {
      readMoreBtn.classList.remove("active");
      readLessBtn.classList.add("active");

      description.style.height = `${fullHeight}px`;

      if (blur) {
        blur.style.opacity = "0";
      }
    });

    readLessBtn.addEventListener("click", () => {
      readMoreBtn.classList.add("active");
      readLessBtn.classList.remove("active");

      description.style.height = `${initialHeight}px`;

      if (blur) {
        blur.style.opacity = "1";
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", initCustomCollapsedText);

document.addEventListener("shopify:section:load", initCustomCollapsedText);
